import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import isArray from 'lodash/isArray';
import noop from 'lodash/noop';
import Accordion from '@Pages/ProfileSettings/Preferences/components/Accordion';
import Button from '@Components/Button';

import './ProfileSettingsAccordionItem.scss';

function ProfileSettingsAccordionItem({
  onClose,
  children,
  onSave,
  label,
  value,
  title,
  className,
  notTagged,
  resetButton,
  onReset,
  formValid = true,
  validateOnSave = false,
}) {
  const [open, setOpen] = useState(false);

  const toggleOpen = () => {
    setOpen(!open);
    onClose();
  };

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  const handleReset = (e) => {
    e.stopPropagation();
    onReset(null, () => setOpen(false));
  };

  const handleSave = () => {
    if (!validateOnSave) {
      onSave();
      setOpen(false);
      return;
    }
    onSave(() => setOpen(false));
  };

  const renderValue = () => {
    if (isArray(value)) {
      return (
        <span className="profile-settings-accordion-row_list">
          {/* eslint-disable-next-line no-shadow */}
          {value.map(({ title, value }, index) => (
            <span
              // eslint-disable-next-line react/no-array-index-key
              key={`${title}-${value}_${index}`}
              className={classnames({
                'profile-settings-accordion-row_list-tagged': !notTagged && value,
              })}>
              {value}
            </span>
          ))}
        </span>
      );
    }

    return (
      <span
        className={classnames({
          'profile-settings-accordion-row_value-tagged': !notTagged && value,
          'profile-settings-accordion-row_value-titled': !value && title,
        })}>
        {value || title}
      </span>
    );
  };

  return (
    <Accordion
      open={open}
      className={className}
      heading={
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
        <div
          className="rx-accordion-row profile-settings-accordion-row"
          onClick={toggleOpen}
          // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
          tabIndex="0"
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              toggleOpen();
            }
          }}>
          {resetButton && (
            <div className="profile-settings-accordion-row_reset">
              <Button
                buttonConfig={{
                  type: 'link',
                  color: 'blue',
                  size: 'sm',
                  label: 'Reset to default',
                  e2eName: 'profile-settings-reset',
                }}
                iconConfig={{
                  name: 'replay',
                  size: 'lg',
                }}
                onClick={handleReset}
                type="button"
              />
            </div>
          )}
          <div className="profile-settings-accordion-row_icon">
            {!open && <i className="ss-write rx-btn-icon" />}
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            {open && <i className="ss-delete rx-btn-icon" onClick={handleClose} />}
          </div>

          <span className="profile-settings-accordion-row_label">{label}</span>
          {!open && renderValue()}
        </div>
      }
      body={
        <div className="profile-settings-accordion-row__content">
          <form noValidate>
            {open ? children : null}
            <div className="profile-settings-accordion-row__content_button u-els-margin-top-2x">
              <Button
                buttonConfig={{
                  type: 'primary',
                  size: 'sm',
                  label: 'Save',
                  e2eName: 'profile-settings-save',
                }}
                iconConfig={{
                  name: 'chevron-right',
                  size: 'sm',
                }}
                disabled={!formValid}
                onClick={handleSave}
                type="button"
              />
            </div>
          </form>
        </div>
      }
    />
  );
}

ProfileSettingsAccordionItem.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  onSave: PropTypes.func.isRequired,
  formValid: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.any,
  title: PropTypes.string,
  validateOnSave: PropTypes.bool,
  className: PropTypes.string,
  notTagged: PropTypes.bool,
  resetButton: PropTypes.bool,
  onReset: PropTypes.func,
};

ProfileSettingsAccordionItem.defaultProps = {
  onReset: noop,
};

export default ProfileSettingsAccordionItem;
